"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.createForm = void 0;
var react_1 = __importDefault(require("react"));
var formik_1 = require("formik");
var FormikAntdFormItem_1 = require("../../FormikAntdFormItem");
var FormItemCustom = FormikAntdFormItem_1.FormikAntdFormItem.FormItemCustom, IsRequiredProvider = FormikAntdFormItem_1.FormikAntdFormItem.IsRequiredProvider;
var createForm = function (_a) {
    var validationSchema = _a.validationSchema, isRequired = _a.isRequired;
    /* Creating provider and required elements. */
    var Provider = function (_a) {
        var children = _a.children;
        var values = formik_1.useFormikContext().values;
        return (react_1.default.createElement(IsRequiredProvider, { isRequired: function (key) { return isRequired(key, values); } }, children));
    };
    var FormItem = function (_a) {
        var children = _a.children, rest = __rest(_a, ["children"]);
        return (react_1.default.createElement(FormItemCustom, __assign({}, rest), children));
    };
    var withFormik = function (Component) {
        return function (_a) {
            var formik = _a.formik, rest = __rest(_a, ["formik"]);
            return (react_1.default.createElement(formik_1.Formik, __assign({}, formik, { validationSchema: validationSchema }),
                react_1.default.createElement(Provider, null,
                    react_1.default.createElement(Component, __assign({}, rest)))));
        };
    };
    return {
        FormItem: FormItem,
        withFormik: withFormik,
    };
};
exports.createForm = createForm;
